<template>
  <div
    class="default-table orders-table"
    :class="{ compact: true }"
  >
    <orderView
      v-if="dialog.selected"
      :value="dialog.selected"
      :dialog="dialog.view"
      @closed="onCloseView"
    />
    <DataTable
      name="orders"
      :items="data"
      :tablehdrs="tableheaders.historic.orders"
      :customdata="true"
      showExpand
    >
      <template v-slot:default="{ item, isExpanded, expand, toggleExpand }">
        <tr
          :key="item.id"
          @click="toggleExpand({ item, isExpanded, expand })"
          @dblclick="viewOrder(item)"
          class="table-row order-row"
          :class="getClasses(item)"
        >
          <td class="expand-col">
            <v-btn
              @click.stop="toggleExpand({ item, isExpanded, expand })"
              icon
              dark
              small
              class="expand-btn mx-2"
              :class="{ active: isExpanded }"
            >
              <v-icon light color="grey darken-4">
                mdi-chevron-down
              </v-icon>
            </v-btn>
          </td>
          <td class="id-col">
            <v-tooltip right v-if="!item.read">
              <template v-slot:activator="{ on }">
                <v-btn icon small v-on="on" class="order-alert">
                  <v-icon small color="red">mdi-exclamation-thick</v-icon>
                </v-btn>
              </template>
              <span>{{ lang.orders.view.unread }}</span>
            </v-tooltip>
            <strong>{{ item.id }}</strong>
          </td>
          <td class="datetime-col">
            {{ formatDate(item.datetime) }}
          </td>
          <td class="customer-col">
            <CustomerCard v-model="item.customer" hideId />
          </td>
          <td class="status-col">
            <v-chip
              dark
              :color="getStatus(item.status).color"
              class="status-chip compact"
            >
              {{ getStatus(item.status).title }}
            </v-chip>
          </td>
          <td v-if="permissions.orders.viewprices" class="total-col">
            {{ formatCurrency(item.total) }}
          </td>
          <td class="actions-col">
            <Actions
              :value="item"
              @input="updateOrderRow"
              @view="viewDialog(item)"
            />
          </td>
        </tr>
      </template>
      <template v-slot:mobile="{ item }">
        <tr
          :key="`mb-${item.id}`"
          @dblclick="viewDialog(item)"
          class="mobile_row table-row order-row"
          :class="getClasses(item)"
        >
          <td class="mobile_col">
            <ul class="flex-content pl-2">
              <li class="flex-item" :data-label="`${lang.orders.datatable.headers.id}:`">
                <v-tooltip right v-if="!item.read">
                  <template v-slot:activator="{ on }">
                    <v-btn icon small v-on="on" class="order-alert">
                      <v-icon small color="red">mdi-exclamation-thick</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ lang.orders.view.unread }}</span>
                </v-tooltip>
                <strong>{{ item.id }}</strong>
              </li>
              <li class="flex-item" :data-label="`${lang.orders.datatable.headers.datetime}:`">
                {{ formatDate(item.datetime) }}
              </li>
              <li class="flex-item" :data-label="`${lang.orders.datatable.headers.customer}:`">
                <CustomerCard v-model="item.customer" hideId />
              </li>
              <li class="flex-item" :data-label="`${lang.orders.datatable.headers.status}:`">
                <v-chip
                  dark
                  :color="getStatus(item.status).color"
                  class="status-chip"
                >
                  {{ getStatus(item.status).text }}
                </v-chip>
              </li>
              <li :data-label="`${lang.orders.datatable.headers.total}:`" class="total-col flex-item">
                {{ formatCurrency(item.total) }}
              </li>
              <li class="flex-item actions_row" :data-label="lang.orders.datatable.headers.action">
                <Actions
                  :value="item"
                  @input="updateOrderRow"
                  @view="viewDialog(item)"
                />
              </li>
            </ul>
          </td>
        </tr>
      </template>
      <template v-slot:expansion>
        <!-- <v-row>
          <v-col cols="1">&nbsp;</v-col>
          <v-col cols="2">data adicionado<br/>última modificação</v-col>
          <v-col cols="2">cliente<br/>cpf - telefone</v-col>
          <v-col cols="2">entrega</v-col>
          <v-col cols="2">histórico</v-col>
          <v-col cols="3">pedido</v-col>
        </v-row> -->
        <td></td>
        <td colspan="2">data adicionado<br/>última modificação</td>
        <td>cpf - telefone</td>
        <td colspan="1">entrega</td>
        <td colspan="2">histórico</td>
        <td colspan="2">pedido</td>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@/templates/global/DataTable'
import CustomerCard from '@/components/customers/templates/MiniCard'
import orderView from '@/components/orders/View'

import Actions from '@/components/orders/templates/Actions'

import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import listDefaults from '@/mixins/defaults/list_subpage'
import orders from '@/components/orders/mixins/index'

export default {
  components: { DataTable, CustomerCard, Actions, orderView },
  mixins: [ appdata, utils, listDefaults, orders ],
  data: () => ({
    default: { ...defaults.blank.order },
    pageName: 'orders'
  }),
  computed: {
    data: {
      get: function () {
        console.log('custom_data', this.socketInfo.custom_data)
        if (this.socketInfo.custom_data && this.socketInfo.custom_data.orders) {
          return this.socketInfo.custom_data.orders
        }
        return []
      }
    }
  }
}
</script>

<style src="@/components/orders/styles/list.scss" lang="scss"></style>
